/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'pidxEscapeHtml',
  standalone: false,
})
@Injectable({
  providedIn: 'root',
})
export class PidxEscapeHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined, ...args: any[]): string {
    return (value ?? '').replace(
      /[&<>'"]/g,
      (tag) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#39;',
          '"': '&quot;',
        })[tag] || tag,
    )
  }
}
